import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

const Router = ({ redirectFrom, redirectTo, routes }) => (
  <Switch>
    {routes.map(route => {
      const { component, defaultPath, optionalPath, path, render } = route;

      const finalPath = path
        ? `${path}${optionalPath || ''}`
        : `${defaultPath}${optionalPath || ''}`;

      return <Route component={component} key={finalPath} path={finalPath} render={render} />;
    })}

    {redirectFrom && redirectTo && (
      <Route path={redirectFrom} render={() => <Redirect from={redirectFrom} to={redirectTo} />} />
    )}
  </Switch>
);

Router.propTypes = {
  redirectFrom: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  routes: PropTypes.array.isRequired,
};

export default Router;
